import { render, staticRenderFns } from "./TagsCheckbox.vue?vue&type=template&id=19603caa&scoped=true&"
import script from "./TagsCheckbox.vue?vue&type=script&lang=js&"
export * from "./TagsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TagsCheckbox.vue?vue&type=style&index=0&id=19603caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19603caa",
  null
  
)

export default component.exports